import { render, staticRenderFns } from "./IframeLingGen.vue?vue&type=template&id=1e0d7bbc&"
import script from "./IframeLingGen.vue?vue&type=script&lang=js&"
export * from "./IframeLingGen.vue?vue&type=script&lang=js&"
import style0 from "./IframeLingGen.vue?vue&type=style&index=0&id=1e0d7bbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports